"use client"

import Link from 'next/link'
import AuthLogo from '../auth-logo'
import { signIn } from "next-auth/react";

import axios from 'axios';
import { useCookies } from 'next-client-cookies';
import { useEffect, useState } from 'react';
import { useTranslations } from 'next-intl';
import { cookies } from 'next/headers'
import Cookies from 'js-cookie';


function encryptToMD5(input: string): string {
  const hexDigits = '0123456789abcdef';
  let result = '';

  for (let i = 0; i < input.length; i++) {
    const char = input.charCodeAt(i);
    result += hexDigits.charAt((char >> 4) & 0x0f) + hexDigits.charAt(char & 0x0f);
  }

  return result;
}



const getUserIP = async (): Promise<string> => {
  try {
    const response = await axios.get('https://api.ipify.org?format=json');
    return response.data.ip;
  } catch (error) {
    console.error('Error fetching IP address:', error);
    return 'Unable to fetch IP';
  }
};

// Fonction pour déterminer le type de device
const getDeviceType = (): string => {
  return navigator.userAgent;
};


function setCookie(name: any, value: any, days: any) {
  const d = new Date();
  d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
  let expires = "expires=" + d.toUTCString();


  // document.cookie = `${name}=${value};${expires};path=/;Secure;SameSite=Strict`;
  Cookies.set(name, value, {
    expires: 7, // Expire dans 7 jours
    path: '/', // Disponible sur l'ensemble du site
    secure: false, // Utilisé uniquement sur les connexions HTTPS
    sameSite: 'lax' // Protéger contre les attaques CSRF
  });
}


async function login(email: string, password: string, t: any): Promise<string> {

  if (!email.includes("@vexub.com")){
    if (password.length < 8) {
        return t("Error: The password is incorrect");
    }
  }
  

  const postData = new URLSearchParams();
  postData.append('email', email);
  postData.append('mdp', encryptToMD5(password));
  console.log(email, password)
  try {
    const URLLogin = process.env.NODE_ENV == "development" ? '/api/login/logindev' : 'https://vexub.fr/api/vexub_v2/compte/login_1.php'
    const response = await axios.post(URLLogin, postData);
    if (response.data.status == "success") {

      setCookie('token', response.data.token, 7);
      setCookie('email', email, 7);

      console.log("oui ici c'est bon")


      window.location.href = "/app";
      return ""
    } else {
      console.log(response);
      return t("Error: The password or the email is incorrect");
    }
  } catch (error) {
    return t("Error: The password or the email is incorrect.");
    console.error("Erreur lors de la requête : " + error);
  }
}



export default function SignInView({ appleLoginUrl }: { appleLoginUrl: string }) {
  const t = useTranslations("Auth")

  const cookies = useCookies();
  const [errorMessageLogin, setErrorMessageLogin] = useState("")
  const [isLoggingIn, setIsLoggingIn] = useState(false)
  // Apple Sign-In : toujours affiche.
  const [showAppleLogin] = useState(true)

  useEffect(() => {

    const token = cookies.get('token');
    const fetchData = async () => {
      try {
        // Définir les données à envoyer
        const data = {
          site_url: window.location.href,
          ip: await getUserIP(),
          device: getDeviceType(),
        };

        // Envoi de la requête POST
        // const response = await axios.post('https://vexub.fr/api/vexub_v2/track/save_tra.php', data, {
        //   headers: {
        //     Authorization: `Bearer ${token}`
        //   }
        // });

        // if (response.data.error === "") {
        //   console.log('Data successfully saved.');
        // }
      } catch (error) {
        console.error('Error fetching profile data:', error);
      }
    };

    fetchData();
  })


  const GoogleSignIn = async () => {
    const { data } = await axios.get('https://vexub.fr/api/vexub_v2/compte/google_geturl.php');
    window.location.href = data.url;
  };


  return (
    <div className="relative w-full min-h-screen flex justify-center items-center flex-col px-4 py-6 sm:py-16 bg-transparent">
      {/* Ambient glow (dark only) */}
      <div
        aria-hidden
        className="hidden dark:block pointer-events-none absolute inset-x-0 top-0 h-[480px] opacity-60"
        style={{ background: "radial-gradient(ellipse 80% 50% at 50% 0%, rgba(168, 85, 247, 0.18), transparent 70%)" }}
      />
      <div className="relative w-full max-w-md rounded-2xl border border-slate-200 dark:border-white/10 bg-white dark:bg-[#111114] shadow-xl shadow-black/5 dark:shadow-black/40 p-5 sm:p-10">
        {/* Mobile: logo aligné à côté du titre */}
        <div className="flex items-center gap-4 mb-6 sm:hidden [&>div]:mb-0">
          <AuthLogo />
          <div>
            <h1 className="text-2xl font-bold tracking-tight text-slate-900 dark:text-white">
              Welcome back
            </h1>
            <p className="text-sm text-slate-500 dark:text-slate-400">
              Sign in to your account
            </p>
          </div>
        </div>

        {/* Desktop: logo centré au-dessus du titre */}
        <div className="hidden sm:flex sm:justify-center sm:mb-8">
          <AuthLogo />
        </div>
        <h1 className="hidden sm:block sm:text-3xl font-bold tracking-tight text-slate-900 dark:text-white text-left mb-2">
          Welcome back
        </h1>
        <p className="hidden sm:block text-sm text-slate-500 dark:text-slate-400 mb-8">
          Sign in to your account
        </p>


        <div>
        <div className='space-y-3'>
          <button id='google_login_button' onClick={() => GoogleSignIn()} className="cursor-pointer inline-flex items-center justify-center rounded-md text-sm font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none ring-offset-background shadow bg-white border border-input hover:bg-accent hover:text-accent-foreground h-10 py-2 px-4 w-full" style={{ background: '#fff', color: '#000', boxShadow: '0 1px 13px 0 rgba(0,0,0,.1),0 1px 2px -1px rgba(0,0,0,.1), 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color)', fontWeight: 600, fontSize: '0.875rem', lineHeight: '1.25rem' }}>
            <span className="mr-2 w-4">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 186.69 190.5">
                <path fill="#4285f4" d="M95.25 77.932v36.888h51.262c-2.251 11.863-9.006 21.908-19.137 28.662l30.913 23.986c18.011-16.625 28.402-41.044 28.402-70.052 0-6.754-.606-13.249-1.732-19.483z"></path>
                <path fill="#34a853" d="m41.869 113.38-6.972 5.337-24.679 19.223c15.673 31.086 47.796 52.561 85.03 52.561 25.717 0 47.278-8.486 63.038-23.033l-30.913-23.986c-8.486 5.715-19.31 9.179-32.125 9.179-24.765 0-45.806-16.712-53.34-39.226z"></path>
                <path fill="#fbbc05" d="M10.218 52.561C3.724 65.376.001 79.837.001 95.25s3.723 29.874 10.217 42.689c0 .086 31.693-24.592 31.693-24.592-1.905-5.715-3.031-11.776-3.031-18.098s1.126-12.383 3.031-18.098z"></path>
                <path fill="#ea4335" d="M95.25 37.927c14.028 0 26.497 4.849 36.455 14.201l27.276-27.276C142.442 9.439 120.968 0 95.25 0 58.016 0 25.891 21.388 10.218 52.561L41.91 77.153c7.533-22.514 28.575-39.226 53.34-39.226"></path>
              </svg>
            </span>
            Continue with Google
          </button>
          {showAppleLogin && (
          <button id='apple_login_button' onClick={() => document.location.href = appleLoginUrl} className="cursor-pointer inline-flex items-center justify-center rounded-md text-sm font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none ring-offset-background shadow bg-white border border-input hover:bg-accent hover:text-accent-foreground h-10 py-2 px-4 w-full" style={{ background: '#fff', color: '#000', boxShadow: '0 1px 13px 0 rgba(0,0,0,.1),0 1px 2px -1px rgba(0,0,0,.1), 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color)', fontWeight: 600, fontSize: '0.875rem', lineHeight: '1.25rem' }}>
            <span className="mr-2 w-4">
              <svg version="1.1" id="fi_747" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 22.773 22.773" xmlSpace="preserve"><g><g><path d="M15.769,0c0.053,0,0.106,0,0.162,0c0.13,1.606-0.483,2.806-1.228,3.675c-0.731,0.863-1.732,1.7-3.351,1.573
			c-0.108-1.583,0.506-2.694,1.25-3.561C13.292,0.879,14.557,0.16,15.769,0z" /><path d="M20.67,16.716c0,0.016,0,0.03,0,0.045c-0.455,1.378-1.104,2.559-1.896,3.655c-0.723,0.995-1.609,2.334-3.191,2.334
			c-1.367,0-2.275-0.879-3.676-0.903c-1.482-0.024-2.297,0.735-3.652,0.926c-0.155,0-0.31,0-0.462,0
			c-0.995-0.144-1.798-0.932-2.383-1.642c-1.725-2.098-3.058-4.808-3.306-8.276c0-0.34,0-0.679,0-1.019
			c0.105-2.482,1.311-4.5,2.914-5.478c0.846-0.52,2.009-0.963,3.304-0.765c0.555,0.086,1.122,0.276,1.619,0.464
			c0.471,0.181,1.06,0.502,1.618,0.485c0.378-0.011,0.754-0.208,1.135-0.347c1.116-0.403,2.21-0.865,3.652-0.648
			c1.733,0.262,2.963,1.032,3.723,2.22c-1.466,0.933-2.625,2.339-2.427,4.74C17.818,14.688,19.086,15.964,20.67,16.716z" /></g><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /></g><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /></svg>

            </span>
            Continue with Apple
          </button>
          )}
        </div>




        {/* Divider */}
        <div className="flex items-center w-full my-5 sm:my-9" id='divider_google'>
          <div className="border-t border-slate-200 dark:border-white/10 flex-1" aria-hidden="true" />
          <div className="text-xs text-slate-400 dark:text-slate-500 uppercase tracking-widest px-4">OR</div>
          <div className="border-t border-slate-200 dark:border-white/10 flex-1" aria-hidden="true" />
        </div>

        <form>
          <div className="space-y-3">
            <input
              id="email"
              className="w-full h-11 px-3.5 rounded-xl border border-slate-200 dark:border-white/10 bg-white dark:bg-[#0d0d10] text-slate-900 dark:text-white placeholder:text-slate-400 dark:placeholder:text-slate-500 outline-none focus:border-purple-500 focus:ring-2 focus:ring-purple-500/20 transition"
              type="email"
              placeholder="Email"
              required
              aria-label="Email"
            />
            <div>
              <input
                id="password"
                className="w-full h-11 px-3.5 rounded-xl border border-slate-200 dark:border-white/10 bg-white dark:bg-[#0d0d10] text-slate-900 dark:text-white placeholder:text-slate-400 dark:placeholder:text-slate-500 outline-none focus:border-purple-500 focus:ring-2 focus:ring-purple-500/20 transition"
                type="password"
                placeholder="Password"
                autoComplete="current-password"
                required
                aria-label="Password"
              />
              <div className="mt-2 text-right">
                <Link className="text-xs font-medium text-purple-600 dark:text-purple-400 hover:text-purple-700 dark:hover:text-purple-300 transition" href="/reset-password">
                  Forgot password?
                </Link>
              </div>
            </div>
          </div>
          <div className="mt-6">
            <button
              type="submit"
              disabled={isLoggingIn}
              className="w-full h-11 inline-flex items-center justify-center gap-2 rounded-xl bg-purple-600 hover:bg-purple-700 disabled:opacity-60 disabled:cursor-not-allowed text-white font-semibold text-sm shadow-lg shadow-purple-900/30 transition focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-purple-500"
              onClick={async (event) => {
                event.preventDefault();
                if (isLoggingIn) return;
                setErrorMessageLogin("")
                setIsLoggingIn(true)
                try {
                  const email = (document.getElementById('email') as HTMLInputElement).value;
                  const password = (document.getElementById('password') as HTMLInputElement).value;
                  const message = await login(email, password, t);
                  setErrorMessageLogin(message)
                } finally {
                  setIsLoggingIn(false)
                }
              }}
            >
              {isLoggingIn && (
                <svg className="animate-spin w-4 h-4" viewBox="0 0 24 24" fill="none" aria-hidden>
                  <circle cx="12" cy="12" r="10" stroke="currentColor" strokeOpacity="0.25" strokeWidth="3" />
                  <path d="M22 12a10 10 0 0 1-10 10" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
                </svg>
              )}
              {isLoggingIn ? "Signing in…" : "Sign in"}
            </button>
          </div>
          {errorMessageLogin && (
            <p className="text-xs text-rose-500 text-center pt-2">{errorMessageLogin}</p>
          )}
        </form>

        <div className="text-center mt-6 pt-4 border-t border-slate-200 dark:border-white/10">
          <div className="text-sm text-slate-500 dark:text-slate-400">
            Don&apos;t have an account? <Link className="font-medium text-purple-600 dark:text-purple-400 hover:text-purple-700 dark:hover:text-purple-300 transition duration-150 ease-in-out" href="/signup">Sign up</Link>
          </div>
        </div>

        </div>
      </div>
    </div>
  )
}